import {MenuItem} from '../models/menu.model';
import {EmployeeModulesEnum} from "../../../modules/app/employees/enums/employee-modules.enum";

// menu items for vertcal and detached layout
const MENU_ITEMS: MenuItem[] = [

    {
        key: 'dashboard',
        label: 'Pulpit',
        isTitle: false,
        icon: 'home',
        module: EmployeeModulesEnum.ORDER,
        link: '/apps/dashboard',
    },
    { key: 'restaurant', label: 'Restauracja', isTitle: true },
    {
        key: 'restaurant-orders-main',
        label: 'Rachunki',
        isTitle: false,
        icon: 'check-square',
        link: '/apps/restaurant/orders',
        children: [
            {
                key: 'restaurant-orders',
                label: 'Lista rachunków',
                link: '/apps/restaurant/orders/list',
                parentKey: 'restaurant-orders-main',
                module: EmployeeModulesEnum.ORDER,
            },
            {
                key: 'restaurant-tables-orders',
                label: 'Rezerwacja stolików',
                link: '/apps/restaurant/table-reservations/list',
                parentKey: 'restaurant-orders-main',
                module: EmployeeModulesEnum.TABLE_RESERVATION,
            }
        ]
    },
    {
        key: 'restaurant-menu-main',
        label: 'Menu',
        isTitle: false,
        icon: 'book',
        link: '/apps/restaurant/menu/details',
    },
    {
        key: 'restaurant-food-package',
        label: 'Ratowanie żywności',
        isTitle: false,
        icon: 'shopping-bag',
        link: '/apps/restaurant/food-packages',
        module: EmployeeModulesEnum.FOOD_PACKAGES,
        children: [
            {
                label: 'Dostępne paczki',
                link: '/apps/restaurant/food-packages',
                parentKey: 'restaurant-food-package',
            },
            {
                label: 'Złożone zamówienia',
                link: '/apps/restaurant/food-packages/orders',
                parentKey: 'restaurant-food-package',
            },
        ]
    },
    {
        key: 'restaurant-stock-main',
        label: 'Magazyn',
        isTitle: false,
        icon: 'layers',
        module: EmployeeModulesEnum.INVENTORY,
        link: '/apps/restaurant/stocks',
        children: [
            {
                label: 'Magazyny',
                link: '/apps/restaurant/stocks',
                parentKey: 'restaurant-stock-main',
            },
            {
                label: 'Półprodukty i receptury',
                link: '/apps/restaurant/stocks/products',
                parentKey: 'restaurant-stock-main',
            },
            {
                label: 'Dokumenty PZ, WZ, PW, Strata',
                link: '/apps/restaurant/stocks/orders',
                parentKey: 'restaurant-stock-orders',
            },
            {
                label: 'Produkcja',
                link: '/apps/restaurant/stocks/production',
                parentKey: 'restaurant-stock-production',
            },
            {
                label: 'Kontakty',
                link: '/apps/restaurant/stocks/contacts',
                parentKey: 'restaurant-stock-orders',
            },
            {
                label: 'Przesunięcia magazynowe',
                link: '/apps/restaurant/stocks/inventory-movements',
                parentKey: 'restaurant-stock-orders',
            },
            {
                label: 'Inwentaryzacje',
                link: '/apps/restaurant/stocks/inventories',
                parentKey: 'restaurant-stock-orders',
            },
        ]
    },
    {
        label: 'Ustawienia restauracji',
        isTitle: false,
        icon: 'settings',
        link: '/apps/restaurant/settings',
        key: 'restaurant-settings',
        module: EmployeeModulesEnum.RESTAURANT_MANAGEMENT,
        children: [
            {
                label: 'Dostępne lokalizacje',
                link: '/apps/restaurant/settings/restaurants',
                parentKey: 'restaurant-settings',
            },
            {
                label: 'O restauracji',
                link: '/apps/restaurant/settings/about',
                parentKey: 'restaurant-settings',
            },
            {
                label: 'Godziny pracy',
                link: '/apps/restaurant/settings/working-hours',
                parentKey: 'restaurant-settings',
            },
            {
                label: 'Strefy dostaw',
                link: '/apps/restaurant/settings/delivery-zones',
                parentKey: 'restaurant-settings',
            },
            {
                label: 'Ustawienia dostaw i zamówień',
                link: '/apps/restaurant/settings/delivery',
                parentKey: 'restaurant-settings',
            },
            {
                label: 'Stoliki',
                link: '/apps/restaurant/settings/tables',
                parentKey: 'restaurant-settings',
            },

        ]
    },
    {
        key: 'restaurant-stats-main',
        label: 'Statystyki i raporty',
        isTitle: false,
        icon: 'bar-chart-2',
        link: '/apps/restaurant/statistics',
        children: [
            {
                key: 'restaurant-stats-reports',
                label: 'Raporty',
                link: '/apps/restaurant/statistics/reports',
                parentKey: 'restaurant-stats-main',
                module: EmployeeModulesEnum.ORDER,
                children: [
                    {
                        key: 'restaurant-stats-reports-financial',
                        label: 'Finansowy',
                        link: '/apps/restaurant/statistics/reports/financial',
                        parentKey: 'restaurant-stats-reports',
                        module: EmployeeModulesEnum.ORDER,
                    },
                    {
                        key: 'restaurant-stats-reports-employees',
                        label: 'Pracowników',
                        link: '/apps/restaurant/statistics/reports/employees',
                        parentKey: 'restaurant-stats-reports',
                        module: EmployeeModulesEnum.ORDER,
                    },
                    {
                        key: 'restaurant-stats-reports-products',
                        label: 'Produktów',
                        link: '/apps/restaurant/statistics/reports/products',
                        parentKey: 'restaurant-stats-reports',
                        module: EmployeeModulesEnum.ORDER,
                    },
                    {
                        key: 'restaurant-stats-reports-couriers',
                        label: 'Kurierów',
                        link: '/apps/restaurant/statistics/reports/couriers',
                        parentKey: 'restaurant-stats-reports',
                        module: EmployeeModulesEnum.COURIERS,
                    },
                    {
                        key: 'restaurant-stats-reports-discounts',
                        label: 'Zniżek',
                        link: '/apps/restaurant/statistics/reports/discounts',
                        parentKey: 'restaurant-stats-reports',
                        module: EmployeeModulesEnum.ORDER,
                    },
                    // {
                    //     key: 'restaurant-stats-reports-orders',
                    //     label: 'Zamkniętych rachunków',
                    //     link: '/apps/restaurant/statistics/reports/orders',
                    //     parentKey: 'restaurant-stats-reports',
                    //     module: EmployeeModulesEnum.ORDER,
                    // },
                ]
            },
            {
                key: 'restaurant-stats-invoices',
                label: 'Faktury VAT',
                link: '/apps/restaurant/statistics/invoices',
                parentKey: 'restaurant-stats-main',
                module: EmployeeModulesEnum.INVOICES,
            },
            {
                key: 'restaurant-stats-orders',
                label: 'Historia rachunków',
                link: '/apps/restaurant/statistics/orders',
                parentKey: 'restaurant-stats-main',
                module: EmployeeModulesEnum.ORDER,
            },
            {
                key: 'restaurant-clients',
                label: 'Klienci',
                link: '/apps/restaurant/statistics/clients',
                parentKey: 'restaurant-stats-main',
                module: EmployeeModulesEnum.CLIENTS,
            },
            {
                key: 'restaurant-review',
                label: 'Opinie',
                link: '/apps/restaurant/statistics/reviews',
                parentKey: 'restaurant-stats-main',
                module: EmployeeModulesEnum.REVIEWS,
            },
        ]
    },
    { key: 'mobile', label: 'Ogólne', isTitle: true },
    {
        key: 'restaurant-marketing-main',
        label: 'Marketing',
        isTitle: false,
        icon: 'inbox',
        link: '/apps/restaurant/marketing',
        children: [
            {
                key: 'restaurant-marketing-promo-codes',
                label: 'Kody rabatowe',
                link: '/apps/restaurant/marketing/promo-codes/list',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.PROMO_CODES,
            },
            {
                key: 'restaurant-marketing-loyalty',
                label: 'Program lojalnościowy',
                link: '/apps/restaurant/marketing/loyalty-program',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.LOYALTY_PROGRAM,
            },
            {
                key: 'restaurant-special-offer-list',
                label: 'Promocje',
                link: '/apps/restaurant/marketing/special-offers',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.SPECIAL_OFFER,
            },
            {
                key: 'restaurant-coupons-list',
                label: 'Kupony',
                link: '/apps/restaurant/marketing/coupons',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.COUPONS,
            },
            {
                key: 'restaurant-cross-selling-list',
                label: 'Cross Selling',
                link: '/apps/restaurant/marketing/cross-selling',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.CROSS_SELLING,
            },
            {
                key: 'restaurant-marketing-campaigns',
                label: 'Kampanie marketingowe',
                link: '/apps/restaurant/marketing/campaigns',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.MARKETING_CAMPAIGN,
            },
            {
                key: 'restaurant-marketing-auto-campaigns',
                label: 'Automatyzacja marketingu',
                link: '/apps/restaurant/marketing/auto-campaigns/list',
                parentKey: 'restaurant-marketing-main',
                module: EmployeeModulesEnum.MARKETING_AUTOMATION,
            }
        ]
    },
    {
        key: 'restaurant-table-order',
        label: 'Zamawianie do stolika',
        isTitle: false,
        mdiIcon: 'mdi-qrcode',
        module: EmployeeModulesEnum.RESTAURANT_MANAGEMENT,
        link: '/apps/restaurant/table-order',
    },
    {
        key: 'restaurant-qr-menu',
        label: 'QR-Menu',
        isTitle: false,
        mdiIcon: 'mdi-qrcode-scan',
        link: '/apps/restaurant/qr-menu',
    },
    {
        key: 'restaurant-kds-app',
        isTitle: false,
        mdiIcon: 'mdi-chef-hat',
        label: 'Fodimi KDS',
        link: '/apps/restaurant/kds-app',
    },
    {
        key: 'restaurant-kiosk',
        isTitle: false,
        mdiIcon: 'mdi-cellphone-settings',
        label: 'Fodimi Kiosk',
        link: '/apps/restaurant/kiosk',
    },
    {
        key: 'restaurant-pos',
        isTitle: false,
        mdiIcon: 'mdi-food',
        label: 'Fodimi POS',
        children: [
            {
                key: 'restaurant-pos-app',
                label: 'Aplikacja POS',
                link: '/apps/pos/app',
                parentKey: 'restaurant-pos',
            },
            {
                key: 'restaurant-pos-discount',
                label: 'Zniżki',
                link: '/apps/pos/discounts',
                parentKey: 'restaurant-pos',
            },
            {
                label: 'Wydruki kuchenne',
                link: '/apps/restaurant/settings/kitchen-printers',
                parentKey: 'restaurant-settings',
            },
        ]
    },
    {
        label: 'Ustawienia',
        isTitle: false,
        icon: 'settings',
        link: '/apps/global/settings',
        key: 'global-settings',
        module: EmployeeModulesEnum.SETTINGS,
        children: [
            {
                key: 'global-settings-online-payment',
                label: 'Płatności online',
                link: '/apps/global/settings/online-payment',
                parentKey: 'global-settings',
            },
            {
                key: 'global-settings-terms',
                label: 'Regulaminy',
                link: '/apps/global/settings/terms',
                parentKey: 'global-settings',
            },
            {
                key: 'global-settings-settings',
                label: 'Ustawienia globalne',
                link: '/apps/global/settings/settings',
                parentKey: 'global-settings',
            },
        ]
    },
    {
        key: 'employees',
        isTitle: false,
        mdiIcon: 'mdi-account-multiple-outline',
        label: 'Pracownicy',
        link: '/apps/employees',
        module: EmployeeModulesEnum.EMPLOYEES,
    },
    {
        key: 'erp',
        isTitle: false,
        mdiIcon: 'mdi-calendar-clock',
        label: 'Rejestr czasu pracy',
        link: '/apps/restaurant/erp',
        module: EmployeeModulesEnum.EMPLOYEES,
    },
    {
        key: 'couriers',
        isTitle: false,
        mdiIcon: 'mdi-moped',
        label: 'Kurierzy',
        link: '/apps/couriers',
        module: EmployeeModulesEnum.COURIERS,
    },
    {
        key: 'integrations',
        isTitle: false,
        mdiIcon: 'mdi-connection',
        label: 'Integracje',
        link: '/apps/integrations',
        module: EmployeeModulesEnum.INTEGRATIONS,
    },
    {
        key: 'food-integrators',
        isTitle: false,
        mdiIcon: 'mdi-food-fork-drink',
        label: 'Zewnętrzne portale',
        link: '/apps/food-integrators',
        module: EmployeeModulesEnum.FOOD_INTEGRATORS,
        children: [
            // {
            //     key: 'food-integrators-list',
            //     label: 'Integracje',
            //     link: '/apps/food-integrators/list',
            //     parentKey: 'food-integrators',
            // },
            {
                key: 'food-integrators-menu',
                label: 'Menu',
                link: '/apps/food-integrators/menu',
                parentKey: 'food-integrators',
            },
            // {
            //     key: 'food-integrators-hours',
            //     label: 'Godziny pracy',
            //     link: '/apps/food-integrators/working-hours',
            //     parentKey: 'food-integrators',
            // },
        ]
    },
    {
        label: 'Rozliczenia',
        isTitle: false,
        icon: 'credit-card',
        link: '/apps/global/billings',
        key: 'global-billings',
        module: EmployeeModulesEnum.BILLINGS,
        children: [
            {
                key: 'global-billings-subscription',
                label: 'Abonament',
                link: '/apps/global/billings/subscription',
                parentKey: 'global-billings',
            },
            {
                key: 'global-billings-invoices',
                label: 'Faktury',
                link: '/apps/global/billings/invoices',
                parentKey: 'global-billings',
            },
        ]
    },
    { key: 'mobile', label: 'Aplikacja mobilna', isTitle: true },
    {
        key: 'mobile-configurator',
        label: 'Konfigurator',
        isTitle: false,
        icon: 'package',
        link: '/apps/mobile/configurator',
        module: EmployeeModulesEnum.APP_CONFIGURATOR,
    },
    {
        key: 'mobile-settings',
        label: 'Ustawienia aplikacji',
        isTitle: false,
        icon: 'smartphone',
        link: '/apps/mobile/settings',
        module: EmployeeModulesEnum.APP_CONFIGURATOR,
    },
    { key: 'web', label: 'Strona internetowa', isTitle: true },
    {
        key: 'web-configurator',
        label: 'Konfigurator i ustawienia',
        isTitle: false,
        icon: 'sliders',
        link: '/apps/web/list',
        module: EmployeeModulesEnum.WEB_CONFIGURATOR,
    },
];

export { MENU_ITEMS };
